<template lang="pug">
  .component-tabbed-client-transactions
    .action-bar
      .title
        h2 Transactions
      .action
        transaction-list-form(:type="'entity-filter'", @filterTransactions="filterTransactions")
    .tabs-inner-content

      base-list(:dataLoader="dataLoader", :component="component", :search="search", componentType="client-list")
        header-columns(slot="before", :columns="headers")
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
  import TransactionListForm from "../../structure/ui/filters/TransactionListForm";
  import BaseList from "../../../pages/backoffice/BaseList";
  import HeaderColumns from "../../structure/ui/HeaderColumns";

  export default {
    name: "TabbedClientTransactions",
    components: {
      HeaderColumns,
      BaseList,
      TransactionListForm,
    },
    data() {
      return {
        component: require('src/components/backoffice/Transaction.vue'),
        headers: ['', 'Date', 'Payment method', 'Invoice', 'Amount', 'Status', ''],
        search: {
          client_id: this.$route.params.id
        }
      }
    },
    created() {
    },
    methods: {
      filterTransactions(body) {
        this.$set(this.search, 'status', body.status)
        if (this.search.status === '') {
          delete this.search.status;
        }
      },
      dataLoader(callback, page, resultsPerPage) {
        KeplerBackofficeSdk.transactions.list(page, resultsPerPage, this.search).all((data) => {
          callback(data)
        })
      }
    },
    computed: {}
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// ClientTransactions.vue?d066c932